import React from 'react';
import { IconWrapper } from '../styles/manualStyles';
import { ArrowLeft, Menu } from 'baseui/icon';
import {
  SendIcon,
  HardDriveUploadIcon,
  HardDriveDownloadIcon,
  SettingsIcon,
  EraserIcon,
  FileTextIcon,
  HomeIcon,
  Share2Icon,
  MonitorPlayIcon,
  ViewIcon,
  PlayIcon,
  PauseIcon,
  RefreshIcon,
  StepForwardIcon,
  StepBackIcon,
  SkipBackIcon,
  FastForwardIcon,
  RewindIcon,
  ClockPlayIcon,
  TimerOffIcon,
  MaximizeIcon,
  QrCodeIcon,
  ControlsIcon,
} from '../styles/iconStyles';

export const iconsMap = {
  SendIcon,
  HardDriveUploadIcon,
  HardDriveDownloadIcon,
  SettingsIcon,
  EraserIcon,
  FileTextIcon,
  HomeIcon,
  Share2Icon,
  MonitorPlayIcon,
  ViewIcon,
  PlayIcon,
  PauseIcon,
  RefreshIcon,
  StepForwardIcon,
  StepBackIcon,
  SkipBackIcon,
  FastForwardIcon,
  RewindIcon,
  ClockPlayIcon,
  TimerOffIcon,
  MaximizeIcon,
  QrCodeIcon,
  ControlsIcon,
  RowActionIcon: () => <span>⋮</span>,
  DragHandleIcon: () => <span>☰</span>,
  ArrowLeft: ArrowLeft,
};

// 再帰的にテキストをパースするヘルパー関数
const parseInline = (text) => {
  if (!text) return [];

  // 太字 (**...**) または アイコン ([...]) で分割
  // 注意: splitの正規表現でキャプチャグループを使うことで、デリミタ自体も結果配列に含まれる
  const parts = text.split(/(\*\*.*?\*\*|\[[\w]+\])/g);

  return parts.map((part, index) => {
    if (!part) return null;

    // アイコンの判定 ([IconName])
    const iconMatch = part.match(/^\[([\w]+)\]$/);
    if (iconMatch) {
      const iconName = iconMatch[1];
      const IconComponent = iconsMap[iconName];
      if (IconComponent) {
        return (
          <IconWrapper key={index}>
            <IconComponent $size={18} />
          </IconWrapper>
        );
      }
      // マップにない場合はそのままテキストとして表示
      return <span key={index}>{part}</span>;
    }

    // 太字の判定 (**Content**)
    const boldMatch = part.match(/^\*\*(.*?)\*\*$/);
    if (boldMatch) {
      const content = boldMatch[1];
      // 太字の中身も再帰的にパース（太字の中にアイコンがある場合などに対応）
      return <strong key={index}>{parseInline(content)}</strong>;
    }

    // 通常テキスト
    return <span key={index}>{part}</span>;
  });
};

/**
 * テキスト内の [IconName] をアイコンコンポーネントに置換してレンダリングします。
 * **Text** は太字にします。
 * ■ で始まる行は行全体を太字にします。
 */
export const renderTextWithIcons = (text) => {
  if (!text) return null;

  // 行ごとに分割して処理
  const lines = text.split('\n');
  return lines.map((line, lineIndex) => {
    const isHeader = line.trim().startsWith('■');
    const content = parseInline(line);

    return (
      <span key={lineIndex}>
        {isHeader ? <strong>{content}</strong> : content}
        {lineIndex < lines.length - 1 && '\n'}
      </span>
    );
  });
};
